import React from 'react';
import { LayoutGrid, MapPin, Route, Layers, Bell, Shield, LogOut } from 'lucide-react';
import { cn } from '../../lib/cn';
import { AtlasLogo } from '../ui';

const ITEMS = [
  { id: 'overview', icon: LayoutGrid, label: 'Overview' },
  { id: 'fleet', icon: MapPin, label: 'Fleet' },
  { id: 'trips', icon: Route, label: 'Trips' },
  { id: 'geofences', icon: Layers, label: 'Geofences' },
  { id: 'alerts', icon: Bell, label: 'Alerts', badge: true },
  { id: 'admin', icon: Shield, label: 'Admin' },
];

export function NavRail({ active = 'fleet', variant = 'rail', onItemClick, onLogout, userName = 'User' }) {
  const wide = variant === 'wide';
  if (variant === 'hidden') return null;
  const width = wide ? 200 : 64;
  return (
    <nav
      aria-label="Primary navigation"
      className="flex flex-col h-screen bg-nav-bg text-nav-ink border-r border-nav-line shrink-0"
      style={{ width }}
    >
      <div className={cn('flex items-center h-[54px]', wide ? 'px-4 justify-start' : 'justify-center')}>
        {wide ? (
          <AtlasLogo size={22} dark drishti={false} />
        ) : (
          <AtlasLogo size={22} wordmark={false} />
        )}
      </div>
      <div className="h-px bg-nav-line mx-2" />
      <ul className="flex-1 overflow-y-auto py-2">
        {ITEMS.map((item) => {
          const Icon = item.icon;
          const isActive = item.id === active;
          return (
            <li key={item.id}>
              <button
                type="button"
                onClick={() => onItemClick?.(item.id)}
                className={cn(
                  'relative flex items-center w-full gap-3 h-10 transition-colors group',
                  wide ? 'px-4' : 'justify-center px-0',
                  isActive
                    ? 'bg-[#1c2940] text-nav-ink'
                    : 'text-nav-ink-2 hover:text-nav-ink hover:bg-nav-bg-2'
                )}
                aria-current={isActive ? 'page' : undefined}
                aria-label={item.label}
              >
                {isActive && !wide && (
                  <span className="absolute left-0 top-1/2 -translate-y-1/2 w-[2px] h-6 bg-accent rounded-r" />
                )}
                <span className="relative">
                  <Icon size={18} strokeWidth={1.7} />
                  {item.badge && (
                    <span className="absolute -top-0.5 -right-0.5 w-[7px] h-[7px] rounded-full bg-bad ring-[1.5px] ring-nav-bg" />
                  )}
                </span>
                {wide && <span className="text-[13px] font-medium">{item.label}</span>}
              </button>
            </li>
          );
        })}
      </ul>
      <div className="h-px bg-nav-line mx-2" />
      <div className={cn('flex items-center gap-3 py-3', wide ? 'px-4' : 'justify-center px-0')}>
        <div className="w-8 h-8 rounded-full bg-accent/90 text-accent-ink flex items-center justify-center text-[12px] font-semibold">
          {userName.slice(0, 1).toUpperCase()}
        </div>
        {wide && (
          <>
            <span className="flex-1 text-[12.5px] text-nav-ink truncate">{userName}</span>
            <button
              type="button"
              onClick={onLogout}
              className="text-nav-ink-2 hover:text-nav-ink"
              aria-label="Log out"
            >
              <LogOut size={16} strokeWidth={1.7} />
            </button>
          </>
        )}
      </div>
    </nav>
  );
}

export default NavRail;
